export default __webpack_public_path__ + "static/media/tamga.7783f568.png";